import React from "react";

export default function AiraBotChat(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#e9f0fe"
          d="M21.399 21.399c-1.168 1.227-2.729 1.974-4.683 2.24-1.371.282-2.943.398-4.716.351-1.772.047-3.344-.07-4.716-.35-1.954-.267-3.515-1.014-4.683-2.241C1.374 20.231.627 18.67.361 16.716.08 15.345-.037 13.773.01 12c-.048-1.772.069-3.344.35-4.716C.627 5.33 1.374 3.77 2.6 2.602 3.77 1.374 5.33.627 7.284.36 8.656.08 10.228-.037 12 .011c1.773-.048 3.345.069 4.716.35 1.954.266 3.515 1.013 4.683 2.24 1.227 1.168 1.974 2.73 2.24 4.683.281 1.372.398 2.944.35 4.716.048 1.773-.069 3.345-.35 4.716-.266 1.954-1.013 3.515-2.24 4.683z"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M7.858 13.586c.418.229.186.73-.348 1.336-.64.725-2.345 1.526-3.343.974a1.24 1.24 0 01-.254-.186c-.932-.885 2.84-2.286 3.378-2.253.254.015.44.06.568.129"
        >
        </path>
        <path
          fill="#5faede"
          d="M7.865 13.562c.403.248.183.78-.33 1.428-.612.772-2.251 1.62-3.214 1.023.996-.106 2.677-.573 3.544-2.451z"
        >
        </path>
        <path
          fill="#b1eced"
          d="M4.771 14.649c.275-.143.752-.334.804-.238.054.097-.332.496-.79.707-.313.144-.718.228-.757.137-.044-.103.384-.42.743-.606z"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M15.787 14.729c.086 2.01-1.159 4.449-3.294 4.57-1.324.077-2.45-.712-3.135-1.812a4.69 4.69 0 01-.71-2.251c-.088-2.06 2.059-2.085 3.417-2.162 1.49-.085 3.252-.306 3.644 1.13.043.155.069.33.077.525"
        >
        </path>
        <path
          fill="#5faede"
          d="M15.789 14.777c.085 1.989-1.15 4.402-3.269 4.523-1.313.075-2.43-.704-3.11-1.793 1.344.573 5.151 1.701 6.301-3.249a2.3 2.3 0 01.077.519"
        >
        </path>
        <path
          fill="#b1eced"
          d="M9.405 14.346c-.264.48-.035 1.131.462 1.364.525.245 1.214-.042 1.382-.598.158-.529-.216-1.09-.724-1.225-.407-.108-.902.06-1.12.458"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M17.366 11.485c-.54.734-1.026 1.066-1.333.472a1.916 1.916 0 01-.142-.39c-.14-.535.474-4.603 1.527-3.85.271.196.442.483.534.819.264.962-.115 2.31-.586 2.949z"
        >
        </path>
        <path
          fill="#5faede"
          d="M17.504 11.622c-.542.73-1.028 1.06-1.335.47.43-.28 1.205-1.085 1.921-3.404.264.957-.116 2.299-.586 2.934z"
        >
        </path>
        <path
          fill="#b1eced"
          d="M16.764 9.395c-.152.615-.471 1.65-.593 1.628-.11-.02-.076-.9.226-1.74.169-.469.437-.973.52-.949.103.03-.105.87-.153 1.06z"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M7.657 9.382a1.496 1.496 0 01-.508-.992 1.533 1.533 0 01.066-.607 1.39 1.39 0 01.796-.863c.104-.041.214-.07.328-.084.43 1.56-.682 2.547-.682 2.547"
        >
        </path>
        <path
          fill="#5faede"
          d="M7.624 9.385a1.423 1.423 0 01-.321-.412c.254-.67.474-1.355.658-2.05.1-.041.206-.07.316-.083l-.653 2.546"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M15.165 9.954c.08 1.995-4.208 3.214-6.38 2.284-.603-.26-1.043-.683-1.18-1.303-.631-2.85.919-5.736 3.034-6.01.767-.1 1.7.088 2.52.666 1.051.742 1.916 2.124 2.005 4.363"
        >
        </path>
        <path
          fill="#294f81"
          d="M13.898 8.403c.044.394-.345.69-.865.903-.547.224-1.24.357-1.725.416-.695.083-2.05.131-2.583-.264a.501.501 0 01-.221-.355c-.023-.205-.005-.413.051-.61s.15-.382.275-.54a1.56 1.56 0 011.03-.591l2.342-.303c.23-.032.463-.009.683.067.22.076.42.203.588.372.23.236.386.548.425.905z"
        >
        </path>
        <path
          fill="#33487a"
          d="M13.899 8.429c.043.385-.342.676-.855.885-.542.221-1.227.352-1.707.409-.688.082-2.028.13-2.555-.257 1.356-.218 3.644-.746 4.697-1.925.228.23.382.538.42.888z"
        >
        </path>
        <path
          fill="#5faede"
          d="M15.164 9.962c.08 1.991-4.225 3.21-6.403 2.281 1.274.054 5.049.043 5.514-1.899.401-1.668-.546-3.704-1.123-4.735 1.054.74 1.922 2.118 2.012 4.353z"
        >
        </path>
        <path
          fill="#b1eced"
          d="M8.573 7.213c.129.142.778-.276 1.2-.697.403-.404.794-1.008.678-1.15-.104-.125-.588.137-.887.359-.668.496-1.13 1.334-.99 1.489zm-.676 3.225c.07.556.402 1.046.512.994.114-.055 0-.715-.092-1.073-.026-.103-.186-.733-.309-.713-.096.017-.156.432-.11.792"
        >
        </path>
        <path
          fill="#393760"
          d="M13.358 8.191a.751.751 0 01-.142.516.672.672 0 01-.196.176.626.626 0 01-.244.083.624.624 0 01-.385-.072.68.68 0 01-.35-.531.749.749 0 01.143-.516.673.673 0 01.196-.176.626.626 0 01.244-.083c.126-.017.254.005.368.063s.21.15.277.266c.047.081.077.174.089.274z"
        >
        </path>
        <path
          fill="#46aed2"
          d="M12.592 7.31a.856.856 0 00-.637.347.934.934 0 00-.09.979.886.886 0 00.363.378.812.812 0 00.5.093.853.853 0 00.576-.34.938.938 0 00.066-1.024.877.877 0 00-.333-.331.809.809 0 00-.445-.102zm.005.131a.72.72 0 01.665.371.79.79 0 01.07.62.8.8 0 01-.146.28.74.74 0 01-.236.193.72.72 0 01-.973-.332.793.793 0 01-.049-.582c.03-.102.08-.197.145-.279a.727.727 0 01.524-.27z"
        >
        </path>
        <path
          fill="#2f4572"
          d="M13.341 7.813c-.188.723-.838.789-1.228.76a.815.815 0 01-.075-.267.808.808 0 01.143-.563.712.712 0 01.473-.294c.135-.018.273.007.395.072s.223.166.291.292"
        >
        </path>
        <path
          fill="#b1eced"
          d="M12.55 7.925a.223.223 0 01-.043.155.202.202 0 01-.058.053.188.188 0 01-.074.024.187.187 0 01-.145-.041.212.212 0 01-.068-.22.217.217 0 01.095-.127.189.189 0 01.073-.025.187.187 0 01.145.042.213.213 0 01.075.14zm.795.318c.04.02.016.26-.143.371-.14.099-.346.065-.355.023-.008-.031.095-.053.255-.178.17-.13.215-.23.243-.216z"
        >
        </path>
        <path
          fill="#393760"
          d="M10.33 8.492a.749.749 0 01-.142.516.636.636 0 01-.826.187.68.68 0 01-.348-.531.75.75 0 01.142-.516c.054-.072.121-.132.197-.177s.158-.072.244-.083a.624.624 0 01.368.064.676.676 0 01.365.54z"
        >
        </path>
        <path
          fill="#46aed2"
          d="M9.565 7.61a.853.853 0 00-.637.347.934.934 0 00-.09.979.886.886 0 00.363.38.812.812 0 00.5.092.845.845 0 00.572-.337.962.962 0 00.185-.67.912.912 0 00-.115-.357.878.878 0 00-.333-.331.81.81 0 00-.445-.102zm.007.132a.718.718 0 01.663.37c.052.09.086.194.098.305a.829.829 0 01-.174.595.742.742 0 01-.236.194.722.722 0 01-.973-.332.792.792 0 01-.05-.583.802.802 0 01.146-.279.742.742 0 01.237-.193.69.69 0 01.289-.077z"
        >
        </path>
        <path
          fill="#2f4572"
          d="M10.314 8.116c-.188.722-.838.787-1.228.757a.814.814 0 01-.076-.265.808.808 0 01.143-.564.711.711 0 01.473-.294.686.686 0 01.688.366z"
        >
        </path>
        <path
          fill="#b1eced"
          d="M9.53 8.365a.224.224 0 01-.042.154.202.202 0 01-.06.053.188.188 0 01-.072.025.187.187 0 01-.145-.042.213.213 0 01-.033-.294.202.202 0 01.06-.053.188.188 0 01.073-.025c.051-.007.103.008.144.042s.068.084.075.139zm.657.187c.04.019.016.26-.143.37-.14.099-.346.065-.355.023-.008-.031.094-.053.255-.177.17-.131.215-.23.243-.216"
        >
        </path>
        <path
          fill="#296abd"
          d="M11.198 7.257c.012.045-.28.193-.59.263-.503.114-.989.008-.988-.051 0-.027.321-.071.965-.16.516-.07.607-.076.613-.052z"
        >
        </path>
        <path
          fill="#5fbbe8"
          d="M7.149 8.013c-.015-.01-.374-.242-.634-.751-.238-.467-.435-1.265-.025-2.417l.194.073c-.306.86-.303 1.61.01 2.23.233.464.561.679.564.681z"
        >
        </path>
        <path
          fill="#294f81"
          d="M7.246 4.72a.585.585 0 01-.181.385.51.51 0 01-.743-.042.562.562 0 01-.133-.404.585.585 0 01.181-.386.51.51 0 01.743.043.562.562 0 01.133.404z"
        >
        </path>
        <path
          fill="#296abd"
          d="M6.448 4.584c.016.153.148.26.294.241a.26.26 0 00.175-.104.284.284 0 00-.043-.392.249.249 0 00-.193-.055.251.251 0 00-.098.033.29.29 0 00-.135.277z"
        >
        </path>
        <path
          fill="#294f81"
          d="M11.488 11.404c-.336.053-.62-.072-.84-.257-.394-.332-.577-.858-.47-.887.167-.045.611.174 1.069.1.525-.083.858-.324 1.125-.383a.477.477 0 01.035-.006c.274-.045.113 1.27-.918 1.433"
        >
        </path>
        <path
          fill="#33487a"
          d="M11.525 11.404c-.326.053-.602-.074-.814-.26.43-.156 1.267-.527 1.666-1.167a.455.455 0 01.034-.006c.265-.044.111 1.271-.887 1.433"
        >
        </path>
        <path
          fill="#c9eaff"
          d="M16.461 21.045c.023.531-1.613 1.056-3.655 1.172-2.041.116-3.714-.22-3.737-.752-.023-.531 1.613-1.057 3.655-1.172 2.041-.116 3.715.221 3.738.752"
        >
        </path>
      </g>
    </svg>
  );
}
